import React, { useState, useEffect, Fragment } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Card, Button, CardTitle, CardText, Row, Col } from 'reactstrap';
import cogoToast from 'cogo-toast';
import { RecaudoContext } from './RecaudoContext';
import PageHeader from '../../components/common/PageHeader';
import RecaudoClient from './childrens/RecaudoClient';
import RecaudoLote from './childrens/RecaudoLote';
import types from '../../data/recaudo/types';
import { creditServices, recaudoServices } from '../../services';

const RecaudarPage = () => {
  const sesion = JSON.parse(sessionStorage.getItem('Usuario'));
  const isAdmin = sesion && sesion.perfil == 1;
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('2');
  const [client, setClient] = useState();
  const [pagSelected, setPagSelected] = useState();
  const [clientCredits, setClientCredits] = useState([]);
  const [creditsPag, setCreditsPag] = useState([]);

  const [recaudoDate, setRecaudoDate] = useState();
  const [fechasCorte, setFechasCorte] = useState([]);
  const [fechaCorteSelected, setFechaCorteSelected] = useState(null);

  const [showModalLote, setShowModalLote] = useState(false);

  useEffect(() => {
    if (!client) return;
    loadClientCredits();
  }, [client])

  const toggleTab = id => {
    setActiveTab(id);
  }

  const loadClientCredits = async () => {
    const response = await creditServices.getCreditsByClient(client.id);
    if (!response || response.error) {
      cogoToast.error(response.msg,
        { position: 'bottom-left', heading: 'Error al cargar los créditos del cliente' });
      return;
    }

    setClientCredits(response.objResponse);
  }

  const loadCreditsByPag = async (pag) => {
    if (!pag) {
      setPagSelected(null);
      setCreditsPag([]);
      setFechasCorte([]);
      setFechaCorteSelected(null);
      return;
    }
    setPagSelected(pag);
    setCreditsPag([]);
    setFechaCorteSelected(null);
    const fechasResponse = await recaudoServices.getFechasCorte(pag.id);
    if (fechasResponse && !fechasResponse.error && fechasResponse.objResponse) {
      setFechasCorte(fechasResponse.objResponse.map(f => ({ value: f, label: f })));
    } else {
      setFechasCorte([]);
    }
  }

  const loadCreditsByFechaCorte = async (fechaCorte) => {
    if (!fechaCorte || !pagSelected) {
      setCreditsPag([]);
      return;
    }
    setLoading(true);
    const response = await creditServices.getCreditsByPagaduria(pagSelected.id, fechaCorte.value);
    setLoading(false);
    if (!response || response.error) {
      cogoToast.error(response.msg,
        { position: 'bottom-left', heading: 'Error al cargar los créditos por lote' });
      return;
    }
    setCreditsPag(response.objResponse);
  }

  const onClientSelect = data => {
    setClient(data)
  }

  const toggleModalLote = (value) => {
    if ((value || !showModalLote) && !pagSelected) return;
    setShowModalLote(value || !showModalLote);
  }

  const handleSaveLote = () => {
    toggleModalLote(false);
    setPagSelected(null);
    setCreditsPag([]);
    setFechasCorte([]);
    setFechaCorteSelected(null);
  }

  const onCancelLote = () => {
    setPagSelected(null);
    setCreditsPag([]);
    setFechasCorte([]);
    setFechaCorteSelected(null);
  }

  const handleCleanClient = () => {
    setClient(null);
    setClientCredits([]);
  }

  const handleRecaudoDate = (value) => {
    setRecaudoDate(value);
  }

  return (
    <RecaudoContext.Provider value={{
      loading,
      recaudoDate,
      client,
      pagSelected,
      clientCredits,
      creditsPag,
      fechasCorte,
      fechaCorteSelected,
      setFechaCorteSelected,
      loadCreditsByFechaCorte,
      onClientSelect,
      showModalLote,
      loadClientCredits,
      handleRefresh: loadClientCredits,
      loadCreditsByPag,
      toggleModalLote,
      handleSaveLote,
      onCancelLote,
      handleCleanClient,
      handleRecaudoDate,
    }}>
      <Fragment>
        <PageHeader title="Recaudo" className="mb-3" >
        </PageHeader>
        <div>
          <Nav tabs className="custom-nav">
            {types && types.filter(type => type.id !== '1' || isAdmin).map((type) => (
              <NavItem className="flex-grow-1 text-center cursor-pointer">
                <NavLink onClick={() => toggleTab(type.id)} className={`p-3  ${activeTab == type.id ? 'active' : ''}`}>
                  {type.name}
                </NavLink>
              </NavItem>
            ))}
          </Nav>
          <TabContent activeTab={activeTab}>
            {isAdmin && (
              <TabPane tabId="1">
                <RecaudoClient />
              </TabPane>
            )}
            <TabPane tabId="2">
              <RecaudoLote />
            </TabPane>
          </TabContent>
        </div>
      </Fragment>
    </RecaudoContext.Provider >
  );
};

export default RecaudarPage
